import { useEffect, useState } from 'react';

import { type MetaCampaignInfo, useGetLeadMetaCampaignInfoQuery } from '../services/api/leads.api';

/**
 * Custom hook to get Meta campaign info for a lead
 * @param leadId - Lead ID
 * @param metaAdId - Meta Ad ID
 * @param isExpanded - Whether the accordion is expanded
 * @returns Meta campaign info or null if not available
 */
const useMetaCampaignInfo = (leadId: number, metaAdId?: number | null, isExpanded?: boolean) => {
  const [metaInfo, setMetaInfo] = useState<MetaCampaignInfo | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  // Only fetch if the conditions are met and the accordion is expanded
  const shouldFetch = isExpanded && metaAdId;

  const {
    data,
    isLoading: queryLoading,
    error,
  } = useGetLeadMetaCampaignInfoQuery(
    { leadId },
    {
      skip: !shouldFetch,
    }
  );

  useEffect(() => {
    setIsLoading(queryLoading);

    if (data) {
      setMetaInfo(data);
    } else if (!shouldFetch) {
      setMetaInfo(null);
    }
  }, [data, shouldFetch, queryLoading]);

  return {
    metaInfo,
    isLoading,
    error,
    hasMetaInfo: !!metaInfo,
  };
};

export default useMetaCampaignInfo;
